<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.service.title.add') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.service.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.service.label.serviceName') }}</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.serviceNameJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.serviceNameJp')"
            id="serviceNameJp"
            solo
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-model="form.serviceNameEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.serviceNameEn')"
            id="serviceNameEn"
            solo
            maxlength="100"
            class="mt-2"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.service.label.serviceDesc') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-textarea
            v-model="form.serviceDscrptnJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.serviceDscrptnJp')"
            id="serviceDscrptnJp"
            solo
            maxlength="1000"
          ></v-textarea>
          <v-textarea
            v-model="form.serviceDscrptnEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.serviceDscrptnEn')"
            id="serviceDscrptnEn"
            solo
            maxlength="1000"
            class="mt-2"
          ></v-textarea>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.service.label.serviceUrl') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.serviceUrl"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.serviceUrl')"
            id="serviceUrl"
            solo
            maxlength="200"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.service.label.displayOrder') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.displayOrder"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.service.ph.displayOrder')"
            id="displayOrder"
            solo
            maxlength="2"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h2>利用設定</h2>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          v-model="form.useGroupList"
          show-select
          item-key="groupSmallId"
          :single-select="false"
          :headers="headers"
          :items="view.groupList"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          disable-pagination
          class="elevation-1"
        >
          <template v-slot:item="{ item, isSelected, select }">
            <tr>
              <td v-if="item.groupLargeName !== undefined"
                  :rowspan="item.groupLargeLength"
                  class="no-hover"
              >{{ item.groupLargeName.ja }}
              </td>
              <td>
                  {{ item.groupSmallName.ja }}
              </td>
              <td align="center">{{ item.displayOrder }}</td>
              <td>
                <v-simple-checkbox :value="isSelected" @input="select($event)" :ripple="false" :id="`groupSmallId-${item.groupSmallId}`" ></v-simple-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">{{ $t('message.admin.mst.service.button.back') }}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goRegister">{{ $t('message.admin.mst.service.button.add') }}</mp-button>
        <mp-dialog regist :show="dialog.registComplete" @clickOk="goList" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminMstService, Common } from '@/api'
import MpError from '@/components/item/MpError'

export default {
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    view: {
      groupList: [],
      headerCheckbox: null,
      errors: []
    },
    form: {
      serviceNameJp: '',
      serviceNameEn: '',
      serviceDscrptnJp: '',
      serviceDscrptnEn: '',
      serviceUrl: '',
      displayOrder: '',
      useGroupList: []
    },
    dialog: {
      registComplete: false
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.mst.service.headers.groupLargeName'), value: 'groupLargeName', sortable: false, width: '40%' },
        { text: i18n.t('message.admin.mst.service.headers.groupSmallName'), value: 'groupSmallName', sortable: false, width: '45%' },
        { text: i18n.t('message.admin.mst.service.headers.displayOrder'), value: 'displayOrder', sortable: false, width: '10%' },
        { text: '', value: 'data-table-select', sortable: false, width: '5%' }
      ]
    }
  },
  methods: {
    goList () {
      this.$router.push({ path: '/admin/mst/service/list' })
    },
    async goRegister () {
      await AdminMstService.register({
        ...this.form,
        // グループ（小分類）のIDのリストでサーバーに送る
        useGroupList: this.form.useGroupList.map(groupSmall => groupSmall.groupSmallId)
      })
        .then(() => { this.dialog.registComplete = true })
        .catch(error => { this.view.errors = error.messages })
    }
  },
  created: async function () {
    // groupSmallのリストを作る。配列の1個目に表示用のgroupLargeNameとグループ小分類の個数を入れる
    this.view.groupList = (await Common.groupList())
      .flatMap(groupLarge => groupLarge.groupSmallList.map((groupSmall, index) => {
        const result = groupSmall
        if (index === 0) {
          result.groupLargeLength = groupLarge.groupSmallList.length
          result.groupLargeName = groupLarge.groupLargeName
        }
        return result
      }))
  }
}
</script>

<style scoped>
  td.no-hover {
    background-color: #FFFFFF
  }
</style>
